import BaseApiClient from '../BaseApiClient';
import { ListDataParams, ListDataResponse } from '../types';
import WorkflowInterface from '@interfaces/Workflow.interface';
import { WorkflowFormInterface } from '../../components/page-components/workflows/WorkflowFormWrapper/types';
import type ApiClient from '../ApiClient';

export class ApiWorkflow extends BaseApiClient {
  private api!: ApiClient;

  setApiClient(api: ApiClient) {
    this.api = api;
  }

  /**
   * Gets list of items
   */
  async list(
    listData: ListDataParams,
    searchTerm?: string
  ): Promise<ListDataResponse<WorkflowInterface>> {
    return new Promise((resolve, reject) => {
      if (searchTerm) {
        if (!listData.filters) listData.filters = {};
        listData.filters.name = searchTerm;
      }
      this.client
        .getList('/workflow', listData)
        .then((res) => {
          if (res.data) {
            resolve({
              items: res.data.data,
              pagination: {
                page: res.data.meta?.current_page,
                perPage: res.data.meta?.per_page,
                total: res.data.meta?.total
              }
            });
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }

  /**
   * Delete a workflow
   */
  async delete(id: number) {
    return this.client.delete(`/workflow/${id}`);
  }

  /**
   * Delete a workflow collection
   */
  async deleteMultiple(ids: number[]) {
    return this.client.delete('/workflow', {
      data: { data: ids.map((value: number) => ({ id: value })) }
    });
  }

  /**
   * Get a workflow
   */
  async get(id: number): Promise<WorkflowInterface> {
    return new Promise((resolve, reject) => {
      this.client
        .get(`/workflow/${id}`)
        .then((res) => {
          if (res.data) {
            resolve(res.data);
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }

  /**
   * Create a workflow
   */
  async create(data: WorkflowFormInterface): Promise<WorkflowInterface> {
    return new Promise((resolve, reject) => {
      this.client
        .post('/workflow', data)
        .then((res) => {
          if (res.data) {
            resolve(res.data);
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }

  /**
   * Update a workflow
   */
  async update(
    id: number,
    data: Partial<WorkflowFormInterface>
  ): Promise<WorkflowInterface> {
    return new Promise((resolve, reject) => {
      this.client
        .put(`/workflow/${id}`, data)
        .then((res) => {
          if (res.data) {
            resolve(res.data);
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }
}

export { workflowQueryKeys } from './query-keys';
export type { WorkflowListQueryParams } from './query-keys';
export { useWorkflowListQuery, useWorkflowQuery } from './use-workflow-queries';
export type { WorkflowFormInterface } from '../../components/page-components/workflows/WorkflowFormWrapper/types';
export {
  useWorkflowCreateMutation,
  useWorkflowDeleteMutation,
  useWorkflowDeleteMultipleMutation,
  useWorkflowUpdateMutation,
  type WorkflowUpdateVariables
} from './use-workflow-mutations';

